export default __webpack_public_path__ + "static/media/cvod-R18.764f742c.svg";